import type { ID } from "@smartsuite/smartsuite-client";

import type { ScrollPosition } from "@smartsuite/grid/lib/hooks/useScrollPosition";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { useLayoutEffect, useMemo, useRef, useState } from "react";
import type { CandidateStore } from "../../../stores/automation/candidate.store";
import type { UserPreferences } from "../../../types/user-preferences";
import type { Workspace } from "../../../types/workspace";
import { ActivityGrid } from "../ActivityGrid/ActivityGrid";
import { ActivityHeader } from "../ActivityHeader/ActivityHeader";
import {
  defaultColumnsWidths,
  getStructure,
} from "../AutomationActivityView/AutomationActivityView.contants";
import { StyledContainer } from "./styles";

interface AutomationActivityGridViewProps {
  candidate: CandidateStore;
  userPreferences: UserPreferences;
  workspace: Workspace;
  isLoading: boolean;
  onScroll: (
    position: ScrollPosition,
    scrollContentSize: {
      height: number;
      width: number;
    },
  ) => void;
  onDetails: (id: ID) => void;
  onGoBack: () => void;
}

export const AutomationActivityGridView =
  observer<AutomationActivityGridViewProps>(
    ({
      isLoading,
      userPreferences,
      workspace,
      candidate,
      onScroll,
      onDetails,
      onGoBack,
    }) => {
      const structure = useMemo(() => getStructure(), []);
      const [headerHeight, setHeaderHeight] = useState(0);
      const headerRef = useRef<HTMLDivElement>(null);
      // TODO: Paste here real value
      const [filterValue, setFilterValue] = useState("all");

      useLayoutEffect(() => {
        if (headerRef.current) {
          const height = headerRef.current.offsetHeight;
          setHeaderHeight(height);
        }
      }, [headerHeight, headerRef]);

      return (
        <StyledContainer>
          <ActivityHeader
            filterValue={filterValue}
            backTooltipText={t("job-list.tooltip-text")}
            isLoading={isLoading}
            ref={headerRef}
            workspace={workspace}
            onGoBack={onGoBack}
            onChangeFilter={setFilterValue}
          />

          <ActivityGrid
            isLoading={isLoading}
            headerHeight={headerHeight}
            columnWidths={defaultColumnsWidths}
            structure={structure}
            visibleFields={structure.map((field) => field.slug)}
            userPreferences={{
              ...userPreferences,
              timezone: {
                ...userPreferences.timezone,
                value:
                  candidate.self.timezone ?? userPreferences.timezone.value,
              },
            }}
            onScroll={onScroll}
            onDetails={onDetails}
          />
        </StyledContainer>
      );
    },
  );
